import { createContext, useContext, type ReactNode } from 'react';
import { useTribeExpeditions } from './data/tribe-expedition-api';
import { civicExpeditionPresentation } from './civic-expedition-presentation';

function useCivicBoard(tribeId: string, enabled: boolean) {
  const query = useTribeExpeditions(tribeId, enabled);
  // A new membership/owner observer must confirm authority before exposing cached actions.
  const data = enabled && query.isFetchedAfterMount ? query.data : undefined;
  return {
    ...query,
    data,
    error: enabled ? query.error : null,
    enabled,
    isPending: enabled && query.isPending,
    presentation: civicExpeditionPresentation(query.error ? undefined : data),
  };
}

const CivicBoardContext = createContext<ReturnType<typeof useCivicBoard> | null>(null);

/** One query observer feeds both world and controls. The owner keys this provider by Tribe. */
export function CivicExpeditionProvider({
  tribeId,
  enabled,
  children,
}: {
  tribeId: string;
  enabled: boolean;
  children: ReactNode;
}) {
  const board = useCivicBoard(tribeId, enabled);
  return <CivicBoardContext.Provider value={board}>{children}</CivicBoardContext.Provider>;
}

export function useCivicExpeditionBoard() {
  return useContext(CivicBoardContext);
}
